<div
  [class.h-13]="!formVisible"
  class="p-3 pt-0">
  <div class="relative flex w-full h-full rounded-lg">
    <button
      (click)="toggleFormVisibility()"
      [ngClass]="{'opacity-0 pointer-events-none': formVisible}"
      class="absolute inset-0 justify-start w-full px-5 rounded-lg"
      disableRipple
      mat-button>
      <mat-icon
        [svgIcon]="'heroicons_outline:plus-circle'"
        class="icon-size-5"></mat-icon>
      <span class="ml-2 text-secondary">{{ buttonTitle }}</span>
    </button>
    <form
      [formGroup]="form"
      [ngClass]="{'opacity-0': !formVisible}"
      class="flex flex-col items-start w-full">
      <div class="flex w-full p-5 rounded-lg shadow bg-card">
        <textarea
          #titleAutosize="cdkTextareaAutosize"
          #titleInput
          (keydown.enter)="save()"
          [formControlName]="'title'"
          [placeholder]="'Título de la tarjeta...'"
          [spellcheck]="'off'"
          cdkTextareaAutosize
          class="w-full text-lg font-medium leading-5">
        </textarea>
      </div>
      <div class="flex items-center mt-2">
        <button
          (click)="save()"
          [color]="'primary'"
          [type]="'button'"
          class="h-8 min-h-8"
          mat-flat-button>
          Añadir tarjeta
        </button>
        <button
          (click)="toggleFormVisibility()"
          [type]="'button'"
          class="ml-1 w-8 h-8 min-h-8"
          mat-icon-button>
          <mat-icon
            [svgIcon]="'heroicons_solid:x'"
            class="icon-size-4"></mat-icon>
        </button>
      </div>
    </form>
  </div>
</div>
